import { render, staticRenderFns } from "./ThemePanel.vue?vue&type=template&id=5d35c8da"
import script from "./ThemePanel.vue?vue&type=script&lang=js"
export * from "./ThemePanel.vue?vue&type=script&lang=js"
import style0 from "./ThemePanel.vue?vue&type=style&index=0&id=5d35c8da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports